import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import Clarity from '@microsoft/clarity'

// 初始化 Microsoft Clarity - 仅在生产环境启用
if (process.env.REACT_APP_ENV === 'prod' && process.env.REACT_APP_CLARITY_PROJECT_ID) {
  Clarity.init(process.env.REACT_APP_CLARITY_PROJECT_ID)
  console.log('Clarity initialized for production environment')
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
)
